import config from "../config";
import { requests } from ".";

export const MoveNumbersService = {
  getInboundNumbers: async (payload) => {
    const { twilioId = "", showOnlyUSCA = "", company_id = "" } = { ...payload };
    const { data } = await requests(config.APP_ENGINE_API_URL).get(
      `twilio/get_inbound_numbers/${twilioId}?company_id=${company_id}&showOnlyUSCA=${showOnlyUSCA}&skipNumberPool=true`
    );
    return data;
  },
  moveNumbers: async (payload) => {
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).post(`/phone-system/numbers/move`, payload);
    return data;
  },
};
